$.fn.bmdIframe = function ( options ) {
    var settings = $.extend ( {
        classBtn: '.bmd-modalButton',
        defaultW: 1000,
        defaultH: 94
    }, options );

    $ ( settings.classBtn ).on ( 'click', function () {

        var el = $ ( this );

        var target = $ ( el ).attr ( 'data-target' ) + ' ';

        var setWidth = parseInt ( $ ( el ).attr ( 'data-bmdWidth' ) || settings.defaultW );
        $ ( target + '.modal-dialog' ).css ( 'width', setWidth + ( setWidth > 100 ? 'px' : '%' ) );

        var setHeight = parseInt ( $ ( el ).attr ( 'data-bmdHeight' ) || settings.defaultH );
        $ ( target + '.modal-dialog' ).css ( 'height', setHeight + ( setHeight > 100 ? 'px' : '%' ) );

        if ( ( $ ( el ).attr ( 'data-title' ) || $ ( el ).text ().length > 0 ) && $ ( target + '.myModalTitle' ) ) {
            $ ( target + '.myModalTitle' ).html ( ( $ ( el ).attr ( 'data-title' ) || $ ( this ).text () ) );
        }

        if ( $ ( el ).attr ( 'data-bmdSrc' ) && $ ( target + '#modal-iframe' ) ) {
            $ ( target + '#modal-iframe' ).attr ( 'src', $ ( el ).attr ( 'data-bmdSrc' ) );
            if( setHeight > 100 ) {
                $ ( target + '#modal-iframe' ).css ( 'height', setHeight - 35 + 'px' );
            }else{
                $ ( target + '#modal-iframe' ).css ( 'height', '99%' );
            }
        }

        if ( $ ( el ).attr ( 'data-contents' ) && $ ( target + '#modal-content' ) ) {
            $ ( target + ' .modal-dialog .modalFrameDiv' ).html ( $ ( el ).attr ( 'data-contents' ) );
        }

        if ( $ ( el ).attr ( 'data-onclick' ) ) {
            $ ( "#modal_close_link" ).attr ( 'onclick', $ ( el ).attr ( 'data-onclick' ) );
        }

    } );

    this.on ( 'hidden.bs.modal', function () {
        var target = $ ( this ).attr ( 'data-target' ) + ' ';
        $ ( target + '#modal-iframe' ).html ( '' );
        $ ( target + '#modal-iframe' ).attr ( 'src', '' );

        if( $ ("#modal_close_link") ) {
            $ ( "#modal_close_link" ).trigger ( 'click' );
            $ ( "#modal_close_link" ).attr ( 'onclick', '' );
        }
    } );

    return this;
};

$( document ).ready(function() {
    $ ( '#myModal' ).bmdIframe ();

});
